// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DoEKT","title":"styles_title__Vd0wm","logosWrapper":"styles_logosWrapper__dnYJA"};